import {Component, Input, OnInit} from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
    ɵFormGroupRawValue,
    ɵTypedOrUntyped,
} from '@angular/forms';
import {BucketName, DocumentAttachment, FileAttachment} from '@npck/af-frontend-api';
import {MAX_FILE_SIZE} from '../../../domain/constants';
import {DropZoneMode, DropZoneStyle, FileData} from '../../drop-zone/drop-zone-controller.component';

@Component({
    selector: 'af-file',
    templateUrl: './file.component.html',
    styleUrl: './file.component.scss',
    standalone: false,
})
export class FileComponent implements OnInit {
    @Input() form: FormGroup<AttachmentForm>;
    @Input() mimeTypes: string[] = ['*'];
    @Input() maxFileSize: number = MAX_FILE_SIZE;
    @Input() dropzoneMode: DropZoneMode = 'drop-zone';
    @Input() multiple: boolean = true;
    @Input() hintTranslationKey: string;
    @Input() hasType: boolean = true;
    @Input() documentAttachment: DocumentAttachment;
    @Input() dropZoneStyle: DropZoneStyle;
    @Input() bucket: BucketName;
    @Input() label: string;
    @Input() parentDictionaryFormControl: FormControl<string>;
    @Input() filterDictionaryBy: string[];
    @Input() excludeFromDictionary: string[] = ['call_rec'];
    @Input() excludeItemsWithCode1 = false;
    @Input() defaultDocType: string;
    @Input() downloadable = false;

    get hasAddDocumentButton(): boolean {
        return !!this.form.controls.files?.value?.filter(item => !item.isDeleted)?.length;
    }

    ngOnInit(): void {
        const mappedFiles = this.documentAttachment?.files?.map(item => <FileData>{
            id: item.id,
            fileName: item.name,
        });
        const initialDocType = this.documentAttachment?.docType ?? this.defaultDocType;
        if (this.hasType) {
            this.form.addControl('fileType', new FormControl(initialDocType));
        }
        this.form.addControl('files', new FormControl({value: mappedFiles, disabled: this.hasType && !initialDocType}));
        if (this.form.hasValidator(Validators.required)) {
            this.hasType && this.form.controls.fileType.setValidators(Validators.required);
            this.form.controls.files.setValidators([requiredFilesValidator()]);
        }
        this.form.controls.fileType?.valueChanges.subscribe(value => {
            if (value) {
                this.form.controls.files.enable();
            }
            this.form.updateValueAndValidity();
        });
    }

}

export function requiredFilesValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control?.value?.filter((item: FileData) => !item.isDeleted)?.length) {
            return {required: true};
        }
        return null;
    };
}

export function createAttachmentRequest(attachment: AttachmentFormValue, isTransactionDeleted = false): DocumentAttachment {
    return <DocumentAttachment>{
        docType: attachment.fileType,
        files: attachment.files.map(file => {
            return <FileAttachment>{
                id: file.id,
                isDeleted: file.isDeleted || isTransactionDeleted,
                name: file.fileName,
            };
        }),

    };
}

export declare type AttachmentFormValue = ɵTypedOrUntyped<AttachmentForm, ɵFormGroupRawValue<AttachmentForm>, any>;

export interface AttachmentForm {
    fileType?: FormControl<string>;
    files?: FormControl<FileData[]>
}
